import React, { useContext, useMemo, useState } from 'react'
import { CheckCircle2, Search, Store } from 'lucide-react'
import ActiveStoreContext from '../../store/ActiveStoreContext'
import AuthContext from '../../store/auth-context'
import styles from './ActiveStoreSelector.module.css'

const ActiveStoreSelector = (props) => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)

    console.log("this is asCtx:  ", asCtx)

    const { isOpen, onClose, onSuccess } = props
    const [searchValue, setSearchValue] = useState('')
    const storesData = JSON.parse(authCtx?.loginData)?.storesData
    const activeStore = (() => {
        try {
            return (asCtx?.activeStore && asCtx.activeStore.trim() !== '') ? JSON.parse(asCtx.activeStore) : null
        } catch {
            return null
        }
    })()

    const activeStoreIdentifier = activeStore?.storeIdentifier || ''

    const filteredStores = useMemo(() => {
        const query = searchValue.trim().toLowerCase()
        if (!query) return Array.isArray(storesData) ? storesData : []

        return (Array.isArray(storesData) ? storesData : []).filter((store) => {
            const haystack = [
                store?.storeName,
                store?.storeAddress,
                store?.storeIdentifier,
            ].join(' ').toLowerCase()

            return haystack.includes(query)
        })
    }, [searchValue, storesData])

    window.onclick = event => event.target.id === "astsmcid" ? onClose() : null
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            onClose()
        }
    });

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainContainer} id="astsmcid" >
                <div className={styles.mainContent}>
                    <div className={styles.topHeader}>
                        <div className={styles.titleRow}>
                            <Store size={14} />
                            <span>Select Active Store</span>
                        </div>
                        <div className={styles.searchWrapper}>
                            <Search size={13} className={styles.searchIcon} />
                            <input
                                type="text"
                                value={searchValue}
                                onChange={(event) => setSearchValue(event.target.value)}
                                placeholder="Search store by name or address"
                                className={styles.searchInput}
                            />
                        </div>
                    </div>
                    <div className={styles.storesWrapper}>
                        {filteredStores.length === 0 && (
                            <div className={styles.emptyState}>
                                No stores found for “{searchValue.trim()}”
                            </div>
                        )}

                        {filteredStores.map((item, index) => {
                            const isActiveStore = item?.storeIdentifier === activeStoreIdentifier

                            return (
                                <div
                                    className={`${styles.eachStoreWrapper} ${isActiveStore ? styles.activeStoreWrapper : ''}`}
                                    key={index}
                                    onClick={() => onSuccess(item)}
                                >
                                    <div className={styles.storeInfoBlock}>
                                        <div className={styles.storeName}>{item?.storeName}</div>
                                        <div className={styles.storeAddress}>{item?.storeAddress}</div>
                                    </div>
                                    {isActiveStore && (
                                        <div className={styles.activeBadge}>
                                            <CheckCircle2 size={13} /> Active
                                        </div>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ActiveStoreSelector